const BUCKET_PATH = 'https://s3.us-east-2.amazonaws.com/with.static/mockusers/';

const videos = [
  `${BUCKET_PATH}arooba_talking.mp4`,
  `${BUCKET_PATH}arooba_listening.mp4`,
  `${BUCKET_PATH}eleanor_talking.mp4`,
  `${BUCKET_PATH}eleanor_listening.mp4`,
  `${BUCKET_PATH}fan_listening.mp4`,
  `${BUCKET_PATH}irina_talking.mp4`,
  `${BUCKET_PATH}irina_listening.mp4`,
  `${BUCKET_PATH}joanne_listening.mp4`,
  `${BUCKET_PATH}lindsey_talking.mp4`,
  `${BUCKET_PATH}lindsey_listening.mp4`,
  `${BUCKET_PATH}blake_listening.mp4`,
  `${BUCKET_PATH}julia_talking.mp4`,
  `${BUCKET_PATH}zareena_listening.mp4`,
  `${BUCKET_PATH}zareena_talking.mp4`,
];

export default videos;
